//#region src/cnx-api/index.ts
/**
* Make a request to the CNX API.
*
* @param service API service/group
* @param action Service action/endpoint
* @param params Endpoint parameters
*/
async function cnxApi(service, action, ...params) {
	const fn = (await (await import("./conf.js")).default[service]()).default.operations[action];
	return await fn(...params);
}

//#endregion
export { cnxApi };